export const thinScrollbarSx = {
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: '#CFCFCF transparent',

  '&::-webkit-scrollbar': {
    width: 4
  },

  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent'
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#CFCFCF',
    borderRadius: 8
  },

  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#B5B5B5'
  }
};

export const tableRowHoverSx = editing => ({
  height: 40,
  cursor: editing ? 'default' : 'pointer',

  '& .MuiTableCell-root': {
    backgroundColor: 'inherit',
    transition: 'background-color 0.2s ease'
  },

  '&:hover': {
    backgroundColor: editing ? '#FFFFFF' : '#FCF8F2'
  },

  '&.MuiTableRow-hover:hover': {
    backgroundColor: editing ? '#FFFFFF' : '#FCF8F2'
  },

  '&.Mui-selected': {
    backgroundColor: '#fff !important'
  },

  '&.Mui-selected .MuiTableCell-root': {
    backgroundColor: '#fff !important'
  },

  '&.Mui-selected:hover': {
    backgroundColor: '#FCF8F2 !important'
  },

  '&.Mui-selected:hover .MuiTableCell-root': {
    backgroundColor: '#FCF8F2 !important'
  }
});

export const panelsWrapperSx = {
  width: '100%',
  height: '100%',
  minHeight: 0,

  display: 'grid',

  gridTemplateColumns: {
    xs: '1fr',
    md: 'minmax(0, 1fr) minmax(0, 1fr)'
  },

  gridTemplateRows: {
    xs: 'minmax(350px, 1fr) minmax(350px, 1fr)',
    md: 'minmax(0, 1fr)'
  },

  gap: 1.5,

  overflow: {
    xs: 'auto',
    md: 'hidden'
  },

  '& > *': {
    width: '100%',
    minWidth: 0,
    minHeight: 0,
    height: '100%'
  }
};